import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import axios from "axios";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import MDButton from "components/MDButton";
import React, { useState, useEffect } from "react";
import MDBackdrop from "components/MDBackdrop";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import { useSnackbar } from "notistack";
import Completion from "./Completion";
import { useMaterialUIController } from "context";
import theme from "assets/theme";
import { Generateqr } from "utils/Generateqr";
import { allowOnlyAlphanumericAndSpace } from "utils/Constant";
import { isValidEmail } from "utils/Constant";
import { isValidPhone } from "utils/Constant";


function PopAddContact(props) {
    const [isDisabled, setIsDisabled] = useState(false);
    const [isBackdrop, setIsBackdrop] = useState(false);
    const { onClose } = props;
    const [controller] = useMaterialUIController();
    const { darkMode } = controller;
    const { sidenavColor } = controller;
    const { enqueueSnackbar } = useSnackbar();
    const [errors, setErrors] = useState({});


    const createUser = (salesManager, dealer) => {
        onClose(false);
        const updatedChargersData = (props.value.chargerInfo).map(charger => ({
            ...charger,
            powerOutput: `${charger.powerOutput} kW`, // Add 'w' to powerOutput for each charger
            energyConsumptions: `0 kWh`,
            costPerUnit: {
                amount: charger.amount ,
                currency: process.env.REACT_APP_CURRENCYCODE
            },
        }));

        const bodyFormData = new FormData();
        (props.value?.locationImage || []).forEach((file, index) => {
            bodyFormData.append('locationImage', file?.originFileObj);
        });
        bodyFormData.append("locationName", props.value.locationName);
        bodyFormData.append("locationType", props.value.locationType);
        bodyFormData.append("state", props.value.state);
        bodyFormData.append("city", props.value.city);
        bodyFormData.append("address", props.value.address);
        bodyFormData.append("status", props.value.status);
        bodyFormData.append("workingDays", props.value.workingDays);
        bodyFormData.append("activeOperationalHoursSlots", JSON.stringify(props.value.slots));
        bodyFormData.append("direction", JSON.stringify(props.value.direction));
        bodyFormData.append("freepaid", JSON.stringify(props.value.freepaid));
        bodyFormData.append("parkingCost", JSON.stringify(props.value.parkingCost));
        bodyFormData.append("salesManager", JSON.stringify(salesManager));
        bodyFormData.append("dealer", JSON.stringify(dealer));
        bodyFormData.append("facilities", JSON.stringify(props.value.facilities));
        bodyFormData.append("chargerInfo", JSON.stringify(updatedChargersData));
        axios({
            method: "post",
            url: process.env.REACT_APP_BASEURL + "charger-locations",
            data: bodyFormData,
            headers: {
                'Content-Type': 'multipart/form-data',
            },
            withCredentials: true,

        })
            .then((response) => {
                if (response.data.success === true) {
                    setIsDisabled(!isDisabled);
                    handleGenerateQRForAllChargers();
                } else {
                    enqueueSnackbar(response.data.message, { variant: 'error' })
                }
            })
            .catch((error) => {
                enqueueSnackbar(error.response.data.message, { variant: 'error' })
            });
    };

    const [values, setValues] = useState(props.value);

    console.log("values", props.value.slots);

    const handleGenerateQRForAllChargers = (props) => {

        if (!values.chargerInfo || values.chargerInfo.length === 0) {
            return;
        }

        for (const charger of values.chargerInfo) {

            const qrData = {
                payload: {
                    connectorId: 1,
                    chargerId: charger.name,
                },
            };

            try {
                Generateqr('encrypt-param', 'POST', qrData);
            } catch (error) {
                console.error('Error generating QR code:', error);
                enqueueSnackbar(`Failed to generate QR code for charger: ${charger.name}`, { variant: 'error' });
                return;
            }
        }

        enqueueSnackbar('QR codes generated successfully for all chargers.', { variant: 'success' });
    };


    useEffect(() => {
        setValues(props.value);
    }, [props.value]);



    const handleSalesManagerChange = (event) => {
        const { name, value } = event.target;

        setValues((prevValues) => ({
            ...prevValues,
            salesManager: {
                ...prevValues.salesManager,
                [name.split('.')[1]]: value
            }
        }));
    };

    const handleDealerChange = (event) => {
        const { name, value } = event.target;

        setValues((prevValues) => ({
            ...prevValues,
            dealer: {
                ...prevValues.dealer,
                [name.split('.')[1]]: value
            }
        }));
    };

    const reset = (event) => {
        event.preventDefault();
        values.salesManager = { name: '', phoneNumber: '', email: '' };
        values.dealer = { name: '', phoneNumber: '', email: '' };
        setValues(props.value);
    }
    const handleClose = () => {
        onClose(false);
    };
    const pop = () => {
        if (!allowOnlyAlphanumericAndSpace(values.salesManager.name)) {
            setErrors((prev) => ({
                ...prev,
                salesManagerName: "Only letters and numbers are allowed",
            }));
            return enqueueSnackbar("Invalid Sales Manager Name", { variant: "error" });
        }
        if (!allowOnlyAlphanumericAndSpace(values.dealer.name)) {
            setErrors((prev) => ({
                ...prev,
                securityGuardName: "Only letters and numbers are allowed",
            }));
            return enqueueSnackbar("Invalid Security Guard Name", { variant: "error" });
        }
        if (!isValidEmail(values.salesManager.email)) {
            setErrors((prev) => ({
                ...prev,
                salesManagerEmail: "Please enter Valid Email Address",
            }));
            return enqueueSnackbar("Invalid Email", { variant: "error" });
        }
        if (!isValidEmail(values.dealer.email)) {
            setErrors((prev) => ({
                ...prev,
                securityGuardEmail: "Please enter Valid Email Address",
            }));
            return enqueueSnackbar("Invalid Email", { variant: "error" });
        }
        if (!isValidPhone(values.dealer.phoneNumber)) {
            setErrors((prev) => ({
                ...prev,
                securityGuardPhoneNumber: "Please enter Valid Phone Number",
            }));
            return enqueueSnackbar("Invalid phone number", { variant: "error" });
        }
        if (!isValidPhone(values.salesManager.phoneNumber)) {
            setErrors((prev) => ({
                ...prev,
                salesManagerPhoneNumber: "Please enter Valid Phone Number",
            }));
            return enqueueSnackbar("Invalid phone number", { variant: "error" });
        }


        if (!values.salesManager.name || !values.salesManager.phoneNumber || !values.salesManager.email || !values.dealer.name || !values.dealer.phoneNumber || !values.dealer.email) return enqueueSnackbar('Please Fill All The Details !!!', { variant: 'error' })
        createUser(values.salesManager, values.dealer);
    };
    const back = () => {
        setIsBackdrop(false);
        onClose(false);
        props.onStateChange(true);
    };

    return (
        <>
            <Completion
                isDialog={isDisabled}
                onClose={setIsDisabled}
                value={values}
            />
            <MDBackdrop isBackdrop={isBackdrop} />
            <Dialog open={props.isDialog} onClose={handleClose} fullWidth={false}   // stop stretching
                PaperProps={{
                    sx: {
                        width: 1000,     // exact width (adjust if needed)
                        borderRadius: "12px",
                    },
                }}>
                <DialogTitle style={darkMode ? { backgroundColor: "#202940", color: "#ffffff", display: "flex", alignItems: "center", justifyContent: "space-between" } : { theme, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    <IconButton aria-label="delete" onClick={back} style={darkMode ? { color: "#ffffff" } : theme}>
                        <ArrowBackIcon />
                    </IconButton>
                    Contact information
                    <IconButton aria-label="delete" onClick={handleClose} style={darkMode ? { color: "#ffffff" } : theme}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent style={darkMode ? { backgroundColor: "#202940", color: "#ffffff" } : theme}>
                    <MDBox pt={0} pb={0} px={3}>
                        <MDBox pt={0}>
                        </MDBox>

                        <MDBox p={2} component="form" role="form">
                            <MDBox p={1}>
                                <MDInput
                                    type="text"
                                    label="Site Engineer Name"
                                    value={values.salesManager.name}
                                    name="salesManager.name"
                                    margin="dense"
                                    fullWidth={true}
                                    onChange={handleSalesManagerChange}
                                    onBlur={(e) => {
                                        const value = e.target.value;
                                        setErrors((prev) => ({
                                            ...prev,
                                            salesManagerName: allowOnlyAlphanumericAndSpace(value)
                                                ? ""
                                                : "Only letters are allowed.",
                                        }));
                                    }}
                                    error={Boolean(errors.salesManagerName)}
                                    helperText={errors.salesManagerName}
                                    FormHelperTextProps={{
                                        sx: {
                                            color: "#d32f2f",
                                            fontSize: "12px",
                                            marginLeft: "4px",
                                        },
                                    }}
                                />
                            </MDBox>

                            <MDBox p={1}>
                                <MDInput
                                    type="email"
                                    label="Site Engineer Email"
                                    value={values.salesManager.email}
                                    name="salesManager.email"
                                    margin="dense"
                                    fullWidth={true}
                                    onChange={handleSalesManagerChange}
                                    onBlur={(e) => {
                                        const value = e.target.value;

                                        setErrors((prev) => ({
                                            ...prev,
                                            salesManagerEmail: isValidEmail(value)
                                                ? ""
                                                : "Enter valid email address.",
                                        }));
                                    }}
                                    error={Boolean(errors.salesManagerEmail)}
                                    helperText={errors.salesManagerEmail}
                                    FormHelperTextProps={{
                                        sx: {
                                            color: "#d32f2f",
                                            fontSize: "12px",
                                            marginLeft: "4px",
                                        },
                                    }}
                                />
                            </MDBox>
                            <MDBox p={1}>
                                <MDInput
                                    type="number"
                                    label="Site Engineer Phone"
                                    value={values.salesManager.phoneNumber}
                                    name="salesManager.phoneNumber"

                                    inputProps={{
                                        pattern: "\\+[1-9]{1}[0-9]{1,2}[0-9]{10}"
                                    }}
                                    margin="dense"
                                    fullWidth={true}
                                    onChange={handleSalesManagerChange}
                                    onBlur={(e) => {
                                        const value = e.target.value;

                                        setErrors((prev) => ({
                                            ...prev,
                                            salesManagerPhoneNumber: isValidPhone(value)
                                                ? ""
                                                : "Enter valid phone Number.",
                                        }));
                                    }}
                                    error={Boolean(errors.salesManagerPhoneNumber)}
                                    helperText={errors.salesManagerPhoneNumber}
                                    FormHelperTextProps={{
                                        sx: {
                                            color: "#d32f2f",
                                            fontSize: "12px",
                                            marginLeft: "4px",
                                        },
                                    }}
                                />
                            </MDBox>
                            <MDBox p={1}>
                                <MDInput
                                    type="text"
                                    label="Security Guard Name"
                                    value={values.dealer.name}
                                    name="dealer.name"
                                    margin="dense"
                                    fullWidth={true}
                                    onChange={handleDealerChange}
                                    onBlur={(e) => {
                                        const value = e.target.value;
                                        setErrors((prev) => ({
                                            ...prev,
                                            securityGuardName: allowOnlyAlphanumericAndSpace(value)
                                                ? ""
                                                : "Only letters are allowed.",
                                        }));
                                    }}
                                    error={Boolean(errors.securityGuardName)}
                                    helperText={errors.securityGuardName}
                                    FormHelperTextProps={{
                                        sx: {
                                            color: "#d32f2f",
                                            fontSize: "12px",
                                            marginLeft: "4px",
                                        },
                                    }}
                                />
                            </MDBox>
                            <MDBox p={1}>
                                <MDInput
                                    type="email"
                                    label="Security Guard Email"
                                    value={values.dealer.email}
                                    name="dealer.email"
                                    margin="dense"
                                    fullWidth={true}
                                    onChange={handleDealerChange}
                                    onBlur={(e) => {
                                        const value = e.target.value;

                                        setErrors((prev) => ({
                                            ...prev,
                                            securityGuardEmail: isValidEmail(value)
                                                ? ""
                                                : "Enter valid email address.",
                                        }));
                                    }}
                                    error={Boolean(errors.securityGuardEmail)}
                                    helperText={errors.securityGuardEmail}
                                    FormHelperTextProps={{
                                        sx: {
                                            color: "#d32f2f",
                                            fontSize: "12px",
                                            marginLeft: "4px",
                                        },
                                    }}
                                />
                            </MDBox>

                       
                            <MDBox p={1}>
                                <MDInput
                                    type="number"
                                    label="Security Guard Phone"
                                    value={values.dealer.phoneNumber}
                                    name="dealer.phoneNumber"

                                    inputProps={{
                                        pattern: "\\+[1-9]{1}[0-9]{1,2}[0-9]{10}"
                                    }}
                                    margin="dense"
                                    fullWidth={true}
                                    onChange={handleDealerChange}
                                    onBlur={(e) => {
                                        const value = e.target.value;

                                        setErrors((prev) => ({
                                            ...prev,
                                            securityGuardPhoneNumber: isValidPhone(value)
                                                ? ""
                                                : "Enter valid phone Number.",
                                        }));
                                    }}
                                    error={Boolean(errors.securityGuardPhoneNumber)}
                                    helperText={errors.securityGuardPhoneNumber}
                                    FormHelperTextProps={{
                                        sx: {
                                            color: "#d32f2f",
                                            fontSize: "12px",
                                            marginLeft: "4px",
                                        },
                                    }}
                                />
                            </MDBox>
                        </MDBox>
                    </MDBox>
                </DialogContent>
                <DialogActions style={darkMode ? { backgroundColor: "#202940", justifyContent: "space-evenly", color: "#ffffff" } : { theme, justifyContent: "space-evenly" }}>

                    <MDButton variant="gradient" color={sidenavColor} onClick={reset}>
                        Reset
                    </MDButton>
                    <MDButton variant="gradient" color={sidenavColor}
                        onClick={pop}
                    >
                        NEXT
                    </MDButton>
                </DialogActions>
            </Dialog>
        </>
    );
}

export default PopAddContact;